import { useNavigate, useParams } from 'react-router-dom';
import { useTelemedicineSession } from '@/hooks/telemedicine';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/Button';

export function CallEndedPage() {
  const navigate = useNavigate();
  const { sessionId } = useParams<{ sessionId: string }>();
  const { data: session } = useTelemedicineSession(sessionId);
  const { user } = useAuth();
  const isDoctor = user?.role === 'DOCTOR';

  const duration = session?.startedAt && session?.endedAt
    ? Math.floor((new Date(session.endedAt).getTime() - new Date(session.startedAt).getTime()) / 1000)
    : 0;

  return (
    <div className="container max-w-2xl py-12 text-center">
      <div className="bg-white rounded-2xl border border-gray-200 p-8">
        <div className="w-20 h-20 bg-green-100 rounded-full mx-auto flex items-center justify-center text-4xl">
          ✓
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mt-4">Consulta Encerrada</h1>
        <p className="text-gray-500 mt-2">
          Duração: {Math.floor(duration / 60)}m {duration % 60}s
        </p>

        <div className="mt-8 space-y-3">
          <Button onClick={() => navigate(isDoctor ? `/medico/telemedicine/summary/${sessionId}` : `/telemedicine/summary/${sessionId}`)}>
            Ver Resumo da Consulta
          </Button>
          <Button variant="outline" onClick={() => navigate(isDoctor ? '/medico/dashboard' : '/dashboard')}>
            Voltar ao Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}